import DeleteButton from 'CMFW/button/DeleteButton';
import NewButton from 'CMFW/button/NewButton';
import ReloadButton from 'CMFW/button/ReloadButton';
import SaveButton from 'CMFW/button/SaveButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Grid from 'CMFW/grid/Grid';
import TextInput from 'CMFW/input/TextInput';
import ItemLayout from 'CMFW/layout/ItemLayout';
import { LoadingItem } from 'CMFW/layout/Loading';
import {
  ContainerLeft,
  ContainerLeftFooter,
  ContainerRight,
  EditorGapGreedy,
  EditorRow,
  ModuleContainer,
} from 'components/common/styles';
import { Split } from 'components/Split';
import { useForceRender } from 'hooks/useForceRender';
import { WordClassSelect } from 'components/selects/WordClassSelect';
import ConjugationRootChangesModel from 'models/ConjugationRootChangesModel';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import { IAppState } from '../../../store/reducers/rootReducer';
import { ICourseConfig } from '../../../store/reducers/courseConfig';
import ConjRootChangesHelp from '../components/ConjRootChangesHelp';

export type IProps = {
  courseId: number;
};

const ConjRootChanges: React.FC<IProps> = (props) => {
  const forceRender = useForceRender();

  const courseConfig: ICourseConfig = useSelector((state: IAppState) => state.courseConfig[props.courseId]);
  const model = useMemo(
    () =>
      new ConjugationRootChangesModel({
        render: forceRender,
        courseId: props.courseId,
        languageId: courseConfig.languageId,
      }),
    [props.courseId, forceRender, courseConfig],
  );

  return (
    <ModuleContainer>
      <ModuleContext.Provider value={model}>
        <Split widthLeft={424}>
          <ContainerLeft>
            <Grid />
            <ContainerLeftFooter>
              <ReloadButton />
              <NewButton />
            </ContainerLeftFooter>
          </ContainerLeft>
          <ContainerRight>
            <ItemLayout>
              <ConjRootChangesHelp />
              <EditorRow>
                <TextInput keyName={'fromText'} label={'from'} />
                <SaveButton />
              </EditorRow>
              <EditorRow>
                <TextInput keyName={'toText'} label={'to'} />
              </EditorRow>
              <EditorRow>
                <TextInputShort keyName={'contextNextEndingStartsWith'} label={'ctx ending starts'} />
              </EditorRow>
              <EditorRow>
                <WordClassSelect isLinked includeAllOption commonOnly />
              </EditorRow>
              <EditorRow>
                <TextInputOrder type={'number'} keyName={'priority'} label={'priority'} />
              </EditorRow>
              <EditorGapGreedy />
              <DeleteButton />
            </ItemLayout>
            <LoadingItem />
          </ContainerRight>
        </Split>
      </ModuleContext.Provider>
    </ModuleContainer>
  );
};

const TextInputOrder = styled(TextInput)`
  width: 80px;
`;

const TextInputShort = styled(TextInput)`
  width: 160px;
`;

export default ConjRootChanges;
